export const VILLAGE_CARD_ROUTE = '/villages/';
